(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initComparador() {
    var comparadores = document.querySelectorAll('.mt-comparador');
    comparadores.forEach(function (comp) {
      var antes = comp.querySelector('.mt-comparador-antes');
      var handle = comp.querySelector('.mt-comparador-handle');
      if (!antes || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = comp.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }

      comp.addEventListener('pointerdown', function (e) {
        dragging = true;
        setPos(e.clientX);
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      window.addEventListener('pointerup', function () { dragging = false; });
      comp.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) setPos(e.touches[0].clientX);
      }, { passive: true });
    });
  }

  function initScrollSuave() {
    document.querySelectorAll('a[href^="#mt-"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        target.classList.remove('mt-atraer');
        // forzar reflow para poder reiniciar la animación si se hace clic varias veces
        void target.offsetWidth;
        target.classList.add('mt-atraer');
        window.setTimeout(function () { target.classList.remove('mt-atraer'); }, 1300);
      });
    });
  }

  function initLikes() {
    document.querySelectorAll('[data-mt-like]').forEach(function (boton) {
      var id = boton.getAttribute('data-block-id');
      var base = parseInt(boton.getAttribute('data-base'), 10) || 0;
      var contador = boton.querySelector('.mt-like-contador');
      var storageKey = 'mt-like-' + id;
      var liked = false;
      try { liked = window.localStorage.getItem(storageKey) === '1'; } catch (e) { liked = false; }

      function pintar() {
        boton.classList.toggle('mt-like-activo', liked);
        boton.setAttribute('aria-pressed', liked ? 'true' : 'false');
        if (contador) contador.textContent = liked ? base + 1 : base;
      }
      pintar();

      boton.addEventListener('click', function () {
        liked = !liked;
        try { window.localStorage.setItem(storageKey, liked ? '1' : '0'); } catch (e) {}
        pintar();
        if (liked && !prefersReducedMotion) {
          boton.classList.remove('mt-like-pop');
          void boton.offsetWidth;
          boton.classList.add('mt-like-pop');
        }
      });
    });
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.mt-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        items.forEach(function (i) { i.classList.remove('mt-abierto'); });
        if (!abierto) item.classList.add('mt-abierto');
      });
    });
  }

  function initCifras() {
    var cifras = document.querySelectorAll('.mt-cifra[data-objetivo]');
    if (!cifras.length) return;
    function animar(el) {
      var objetivo = parseFloat(el.getAttribute('data-objetivo')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * objetivo);
        el.textContent = valor + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = objetivo + sufijo;
      }
      if (prefersReducedMotion) {
        el.textContent = objetivo + sufijo;
        return;
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) {
      cifras.forEach(animar);
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    cifras.forEach(function (el) { obs.observe(el); });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('.mt-galeria-principal img');
      var miniaturas = galeria.querySelectorAll('.mt-miniatura');
      miniaturas.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          if (principal && src) principal.src = src;
          miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
          mini.classList.add('mt-miniatura-activa');
        });
      });
    });
  }

  function initVariantes() {
    var form = document.getElementById('mt-producto-form');
    if (!form) return;
    var dataEl = document.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-mt-opcion]');
    var input = form.querySelector('input[name="id"]');
    var precioEl = document.querySelector('[data-mt-precio-actual]');
    var precioAnteriorEl = document.querySelector('[data-mt-precio-anterior]');
    var btnComprar = form.querySelector('[data-mt-btn-comprar]');
    var msgAgotado = document.querySelector('[data-mt-agotado-msg]');

    function formatoMoneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    function seleccionActual() {
      var vals = [];
      selects.forEach(function (sel) {
        var activo = sel.querySelector('.mt-opcion-activa');
        vals.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return vals;
    }

    function encontrarVariante() {
      var vals = seleccionActual();
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === vals[i]; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      if (input) input.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioAnteriorEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnteriorEl.textContent = formatoMoneda(variante.compare_at_price);
          precioAnteriorEl.style.display = '';
        } else {
          precioAnteriorEl.style.display = 'none';
        }
      }
      if (btnComprar) {
        btnComprar.disabled = !variante.available;
        btnComprar.textContent = variante.available
          ? btnComprar.getAttribute('data-texto-disponible')
          : btnComprar.getAttribute('data-texto-agotado');
      }
      if (msgAgotado) msgAgotado.style.display = variante.available ? 'none' : '';

      if (variante.image) {
        var galeriaImg = document.querySelector('[data-mt-galeria] .mt-galeria-principal img');
        if (galeriaImg) galeriaImg.src = variante.image;
        document.querySelectorAll('[data-mt-galeria] .mt-miniatura').forEach(function (m) {
          m.classList.remove('mt-miniatura-activa');
        });
      }

      selects.forEach(function (sel) {
        sel.querySelectorAll('.mt-opcion-valor').forEach(function (btn) {
          var valor = btn.getAttribute('data-valor');
          var idxGrupo = Array.prototype.indexOf.call(selects, sel);
          var valsPrueba = seleccionActual().slice();
          valsPrueba[idxGrupo] = valor;
          var existeDisponible = variantes.some(function (v) {
            return v.options.every(function (opt, i) { return opt === valsPrueba[i]; }) && v.available;
          });
          btn.disabled = !existeDisponible;
        });
      });
    }

    form.querySelectorAll('.mt-opcion-valor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var grupo = btn.closest('[data-mt-opcion]');
        grupo.querySelectorAll('.mt-opcion-valor').forEach(function (b) { b.classList.remove('mt-opcion-activa'); });
        btn.classList.add('mt-opcion-activa');
        actualizar();
      });
    });

    var cantidadInput = form.querySelector('[data-mt-cantidad-input]');
    form.querySelectorAll('[data-mt-cantidad-menos]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cantidadInput) return;
        cantidadInput.value = Math.max(1, (parseInt(cantidadInput.value, 10) || 1) - 1);
      });
    });
    form.querySelectorAll('[data-mt-cantidad-mas]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cantidadInput) return;
        cantidadInput.value = (parseInt(cantidadInput.value, 10) || 1) + 1;
      });
    });

    actualizar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initComparador();
    initScrollSuave();
    initLikes();
    initFaq();
    initCifras();
    initGaleriaProducto();
    initVariantes();
  });
})();
